<template>
    <div class="container tile">
        <LoadingPlaceholder v-if="loading" />
        <div v-if="!loading" class="col-sm-6 mx-auto">
            <h1>Multi-factor Authentication Settings</h1>
            <div class="card">
                <div class="card-body">
                    <p class="card-text">This increases your account security when signing in to AccessGov. Only one multi-factor authentication method can be active.</p>
                </div>
                <ul class="list-group list-group-flush">
                    <li class="list-group-item" v-for="val in availableFactors">
                        <div class="row">
                            <div class="col-sm-9">
                                <p class="card-text">{{ val.name }}</p>
                            </div>
                            <div class="col-sm-3" v-if="val.isNew">
                                <input type="button" value="Set Up" class="btn btn-primary" @click.prevent="submit(val.value)" />
                                <!--<button @click.prevent="$emit('change-page', { page: 'MultiFactorAuthenticationGenerateToken', settings: { code: 'New',mfaFactorType:val.value } })" :href="newUrl" class="btn btn-primary btn-sm w-100">Set Up</button>-->
                            </div>
                            <div class="col-sm-3" v-else>
                                <input type="button" value="Edit" class="btn btn-primary" @click.prevent="submit(val.value)" />
                                <!-- <button @click.prevent="$emit('change-page', { page: 'MultiFactorAuthenticationGenerateToken', settings: { code: 'Edit' ,mfaFactorType:val.value } })" :href="editUrl" class="btn btn-primary btn-sm w-100">Edit</button>-->
                            </div>
                        </div>
                    </li>
                </ul>
            </div>
        </div>
    </div>
</template>
<script lang="ts">
import { defineComponent, ref, inject, onActivated } from "vue";
import LoadingPlaceholder from "@/lib/LoadingPlaceholder.3.vue";
import generateToken from "../../../lib/generateToken";
import getData from "@/admin/lib/getData";
import { useMainStore } from "@/mainStore";
import { changePageInjectKey } from "@/AppShell.3.vue.InjectKeys";
import { GetFactorsResult } from "@cs/GetFactorsResult";
export default defineComponent({
    components: {
        LoadingPlaceholder,
    },
    setup() {
        const mainStore = useMainStore();
        const loading = ref(true);
        const configuredFactors = ref([] as NonNullable<GetFactorsResult["AvailableFactors"]>);
        const availableFactors = ref([] as { name: string; value: number; isNew: boolean }[]);
        const saveStatus = ref(null as null | "in-progress" | "ok" | "fail");
        const saveErrors = ref([] as string[]);
        const changePage = inject(changePageInjectKey)!;
        const submit = async (factorType: number) => {
            saveStatus.value = "in-progress";
            const tokenType = "Authentication";
            try {
                const json = await generateToken(mainStore, () => mainStore.getUrl("multiFactorAuthenticationGenerateToken"), tokenType, null!);
                if (json.Success) {
                    saveStatus.value = "ok";
                    changePage({
                        page: "MultiFactorAuthenticationVerifyToken",
                        settings: { tokenType: tokenType, factorType: factorType },
                    });
                } else {
                    saveStatus.value = "fail";
                    saveErrors.value = json.Errors || ["Unknown error occurred"];
                }
            } catch {
                saveStatus.value = "fail";
                saveErrors.value = ["Unknown error occurred"];
            }
        };
        const init = async () => {
            loading.value = true;
            const factors = (await getData(mainStore, "WisconsinDefault", () => mainStore.getUrl("multiFactorAuthenticationIndexData"))) as GetFactorsResult;
            configuredFactors.value = factors.ConfiguredFactors!;
            if (factors.AvailableFactors != null) {
                availableFactors.value = factors.AvailableFactors.map(i => ({
                    name: i.Name!,
                    value: i.Value!,
                    isNew: !configuredFactors.value.some(data => data.Value == i.Value),
                }));
            }
            loading.value = false;
        };
        onActivated(() => {
            init();
        });

        const result = {
            loading,
            availableFactors,
            submit,
        };
        ("#if JEST");
        //@ts-ignore
        result.init = init;
        //@ts-ignore
        result.saveStatus = saveStatus;
        ("#endif");
        return result;
    },
});
</script>
